export default __webpack_public_path__ + "static/redcliffe-972f604fb200690f068fef0e493dd6a3.png";